import { Component, OnInit } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
import { CollectionService } from "../../collections/collection.service";

@Component({
  selector: "app-edit-coupon-user-info",
  standalone: true,
  imports: [TranslateModule, ReactiveFormsModule, CommonModule, NgSelectModule],
  templateUrl: "./edit-coupon-user-info.html",
  styleUrl: "./edit-coupon-user-info.scss",
})
export class EditCouponUserInfoComponent implements OnInit {
  userId: number = 0;
  isLoading = false;
  isLoadingProject = false;
  modalType: "edit" | "new" = "edit";
  user: any = {};
  couponUserInfoForm: FormGroup;
  salesOptions: any = [];
  sales: any[] = [];
  um = [
    { id: 1, name: this.translateService.instant("ums.pcs") },
    { id: 2, name: this.translateService.instant("ums.sqm") },
    { id: 3, name: this.translateService.instant("ums.lm") },
  ];

  professionOptions = [
    {
      id: "Privato",
      name: "Частное лицо",
    },
    {
      id: "Architetto – Designen",
      name: "Архитектор - дизайнер",
    },
    {
      id: "Investitore",
      name: "Инвестор",
    },
    {
      id: "Paesaggista",
      name: "Ландшафтный дизайнер",
    },
    {
      id: "Impresa edile – Azienda di posa piastrelle",
      name: "Строительная компания - Компания по укладке плитки",
    },
  ];

  constructor(
    //private idaParticipantsService: IdaParticipantsService,
    private translateService: TranslateService,
    private activeModal: NgbActiveModal,
    private collectionService: CollectionService,
    private fb: FormBuilder,
  ) {
    this.initForm();
    this.getProductsOptions();
  }

  ngOnInit(): void {
    this.isLoadingProject = true;
    if (this.modalType === "new") {
      this.user = {};
      this.addNewProduct();
    } else {
      this.getUserData();
    }
  }

  getProductsOptions() {
    this.collectionService.getProducts().subscribe({
      next: (response: any) => {
        if (response.success) {
          this.salesOptions = response.data.map((product: any) => ({
            name: product.name,
            unit: product.uom,
            code: product.code,
          }));
        }
        this.isLoadingProject = false;
      },
      error: (error: any) => {
        this.isLoadingProject = false;
      },
    });
  }

  getUserData() {
    if (!this.user.id) return;
    this.collectionService.getUserDetail(this.user.id).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.user = response.data;
          this.couponUserInfoForm.patchValue({
            name: this.user.name ?? "",
            surname: this.user.surname ?? "",
            email: this.user?.email ?? "",
            phone: this.user.phone ?? "",
            profession: this.user.profession ?? "",
            city: this.user.city ?? "",
          });
          this.user.products.forEach((product: any) => {
            this.salesFormArray.push(this.createSaleFormGroup());
            const quantityWithComma =
              product.quantity !== null && product.quantity !== undefined
                ? product.quantity.toString().replace(".", ",")
                : null;
            this.salesFormArray.at(this.salesFormArray.length - 1).patchValue({
              quantity: quantityWithComma,
              unit: product.uom,
              code: product.code,
              id: product.id,
            });
          });
        }
        this.isLoadingProject = false;
      },
      error: (error: any) => {
        this.isLoadingProject = false;
      },
    });
  }

  quantityValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      // Accetta stringhe con numeri e virgola
      if (value === null || value === undefined || value === "") {
        return { required: true };
      }

      // Converti la virgola in punto per il controllo numerico
      const numericValue = parseFloat(value.toString().replace(",", "."));

      if (isNaN(numericValue)) {
        return { notANumber: true };
      }

      if (numericValue <= 0) {
        return { notGreaterThanZero: true };
      }

      return null;
    };
  }

  initForm() {
    this.couponUserInfoForm = this.fb.group({
      // name: ["", Validators.required],
      // surname: ["", Validators.required],
      // email: ["", [Validators.required, Validators.email]],
      // phone: ["", Validators.required],
      // profession: ["", Validators.required],
      // city: ["", Validators.required],
      sales: this.fb.array(
        [],
        [
          this.uniqueProductCodeValidator(),
          ...(this.modalType === "new"
            ? []
            : [this.atLeastOneRequiredValidator()]),
        ],
      ),
    });
  }

  get salesFormArray(): FormArray {
    return this.couponUserInfoForm.get("sales") as FormArray;
  }

  // Create a new FormGroup for a single sale item
  createSaleFormGroup(): FormGroup {
    return this.fb.group({
      id: [null],
      quantity: [null, [Validators.required, this.quantityValidator()]],
      unit: [""],
      code: ["", Validators.required],
    });
  }

  addNewProduct() {
    this.salesFormArray.push(this.createSaleFormGroup());
  }

  removeSale(index: number) {
    let optionCodeRemoved = this.salesFormArray.at(index)?.get("code")?.value;
    this.salesFormArray.removeAt(index);
    this.salesOptions.forEach((element: any) => {
      if (optionCodeRemoved === element.code) {
        element["disabled"] = false;
      }
    });
  }

  onOptionSelected(event: any) {
    this.salesOptions.forEach((element: any) => {
      if (event.code === element.code) {
        element["disabled"] = true;
      }
    });
  }

  close() {
    this.activeModal.dismiss();
  }
  saveCouponInfo() {
    if (!this.couponUserInfoForm.invalid) {
      let userData: any = {
        // name: this.couponUserInfoForm.value.name,
        // surname: this.couponUserInfoForm.value.surname,
        // email: this.couponUserInfoForm.value.email,
        // phone: this.couponUserInfoForm.value.phone,
        // profession: this.couponUserInfoForm.value.profession,
        // city: this.couponUserInfoForm.value.city,
        //coupon: this.user.coupon,
        products: this.couponUserInfoForm.value.sales.map((sale: any) => {
          const product = this.salesOptions.find(
            (opt: any) => opt.code === sale.code,
          );
          let quantity = sale.quantity;
          if (typeof quantity === "string") {
            quantity = quantity.replace(",", ".");
          }
          return {
            code: product?.code ?? "",
            quantity: quantity,
          };
        }),
      };

      if (this.modalType === "new") {
        this.collectionService.addNewCustomer(userData).subscribe({
          next: (response: any) => {
            if (response.success) {
              const success =
                this.translateService.instant("success.user_saved");
              this.activeModal.close(this.couponUserInfoForm.value);
            }
          },
        });
      } else {
        userData["id"] = this.user.id;
        this.collectionService.activateCoupon(userData).subscribe({
          next: (response: any) => {
            if (response.success) {
              const success =
                this.translateService.instant("success.user_saved");
              this.activeModal.close(this.couponUserInfoForm.value);
            }
          },
        });
      }
    }
  }

  onQuantityInput(event: any, control: AbstractControl | null) {
    if (!control) return;

    let inputValue = event.target.value;

    // Consenti solo cifre e una virgola
    const validPattern = /^\d*(,\d*)?$/;
    if (!validPattern.test(inputValue)) {
      inputValue = inputValue.slice(0, -1);
    }

    // Aggiorna il campo visivo
    event.target.value = inputValue;

    // Non modificare FormControl qui: lasciamo il validator gestire la conversione
    control.setValue(inputValue, { emitEvent: false });
  }

  greaterThanZeroValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      // Check if the value is a valid number
      if (value === null || value === undefined || isNaN(value)) {
        return { notANumber: true };
      }

      // Check if the value is greater than 0
      if (Number(value) <= 0) {
        return { notGreaterThanZero: true };
      }

      return null;
    };
  }

  atLeastOneRequiredValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const formArray = control as FormArray;
      if (formArray.length < 1) {
        return { atLeastOneRequired: true };
      }
      return null;
    };
  }

  uniqueProductCodeValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const formArray = control as FormArray;
      const codes: string[] = [];
      let isDuplicate = false;

      // Iterate through all FormGroups (sales) in the FormArray
      for (const group of formArray.controls) {
        const codeControl = group.get("code");

        if (codeControl && codeControl.value) {
          const code = codeControl.value;

          // Check for duplicates
          if (codes.includes(code)) {
            isDuplicate = true;
            break; // Found a duplicate, no need to continue
          }

          codes.push(code);
        }
      }

      // Return the error object if duplicates are found
      if (isDuplicate) {
        return { duplicateProductCode: true };
      }

      return null; // No errors
    };
  }
}
